import React, { useState, useEffect } from "react";
import styles from "./Resources.module.css";
import ImportImageModal from "../../Components/Modals/ImportModal/ImportImageModal";
import { connect, useDispatch } from "react-redux";
import AddResources from "../../Components/Modals/AddResourcesModal/AddResourceModal";
import {
  fetchResources,
  createLocation,
  createBudget,
  deleteCarouselImage,
  createLeadSource,
  deleteLocation,
  deleteBudget,
  deleteLeadSource,
  editLocation,
  editLeadSource,
  editBudget,
  createCommercialType,
  createResidentialType,
  editResType,
  editCommType,
  deleteResidential,
  deleteComType,
  createTransferReason,
  createPropertyType,
  createPropertyStage,
  createPropertySubType,
  editTransferReason,
  deleteTransferReasonProcess,
  editPropertyStage,
  deletePropertyStageProcess,
  editPropertyType,
  deletePropertyTypeProcess,
  deletePropertySubTypeProcess,
  editPropertySubType,
} from "../../Services/resources";
import { getDateString } from "../../Values/utils";
import { showSnackbarAction } from "../../Redux/actions";
import Loading from "../../Components/Loading/Loading";
import { MdDelete } from "react-icons/md";
import { FiEdit3 } from "react-icons/fi";
import EditResources from "../../Components/Modals/AddResourcesModal/EditResourceModal";
import { Table, TableHead, TableBody, TableRow, TableCell, Button, Box, Grid, Typography, Avatar, useMediaQuery, useTheme } from "@mui/material";
import { themeColors } from "../../Components/theme";
import { CSVLink } from "react-csv";
import ImportModelLoaction from './ImportLocationModal';
import ImportModelLeadSource from './ImportLeadSourceModal';
import ImportModelBudget from './ImportBudgetModal';
import ImportCommercialTypeModal from './ImportCommercialTypeModal';
import ImportResidentialTypeModal from './ImportResidentialTypeModal';
import ImportTransferReasonModal from './TransferReasonModel'
import ImportPropertyTypeModel from "./ImportPropertyTypeModel";
import ImportPropertyStageModal from "./ImportPropertyStageModal";
import ImportPropertySubTypeModal from "./ImportPropertySubTypeModal";
import { v4 as uuidv4 } from 'uuid';
import { deleteApi, editAutoApi } from "../../Services/organizations";
import "../../theme-vars.css";
import { BsPlus } from "react-icons/bs";
import StyledButtonHeader from "../../Components/Buttons/StyledButtonHeader";
import { BiImport, BiExport } from "react-icons/bi";

const fontStylesMedium = {
  fontFamily: "var(--font-family-main)",
  fontSize: "var(--font-size-medium)"
};

const fontStylesSmall = {
  fontFamily: "var(--font-family-main)",
  fontSize: "var(--font-size-small)"
};

const Resources = ({ history, user, theme, conatctHeader }: any) => {
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const dispatcher = useDispatch();
  const [openLocation, setOpenLocation] = useState(false);
  const [openBudget, setOpenBudget] = useState(false);
  const [openLeadSource, setOpenLeadSource] = useState(false);
  const [openCommercial, setOpenCommercial] = useState(false);
  const [openResidential, setOpenResidential] = useState(false);
  const [openTransferReason, setOpenTransferReason] = useState(false);
  const [openPropertyType, setOpenPropertyType] = useState(false);
  const [openPropertyStage, setOpenPropertyStage] = useState(false);
  const [openPropertySubType, setOpenPropertySubType] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editValue, setEditValue] = useState("");
  const [leadSourceId, setLeadSourceId] = useState("");
  const [editModalType, setEditModalType] = useState<"Location" | "Budget" | "Lead Source" | "Residential" | "Commercial" | "Transfer Reason" | "Property Stage" | "Property Type" | "Property Sub Type">("Location");
  const [importImageModal, setImportImageModal] = useState(false);
  const [locationsList, setLocationsList] = useState<any[]>([]);
  const [locationsListFormat, setLocationsListFormat] = useState<any[]>([]);
  const [budgetsList, setBudgetsList] = useState<any[]>([]);
  const [budgetsListFormat, setBudgetsListFormat] = useState<any[]>([]);
  const [leadSourceList, setLeadSourceList] = useState<any[]>([]);
  const [leadSourceListFormat, setLeadSourceListFormat] = useState<any[]>([]);
  const [carouselList, setCarouselList] = useState<any[] | undefined>(undefined);
  const [comTypes, setComTypes] = useState<any[]>([]);
  const [comTypesFormat, setComTypesFormat] = useState<any[]>([]);
  const [resTypes, setResTypes] = useState<any[]>([]);
  const [resTypesFormat, setResTypesFormat] = useState<any[]>([]);
  const [transferReasons, setTransferReasons] = useState<any[]>([]);
  const [propertyTypes, setPropertyTypes] = useState<any[]>([]);
  const [propertyStage, setPropertyStage] = useState<any[]>([]);
  const [propertySubType, setPropertySubType] = useState<any[]>([]);
  const [transferReasonsFormat, setTransferReasonsFormat] = useState<any[]>([]);
  const [propertyTypeFormat, setPropertyTypeFormat] = useState<any[]>([]);
  const [propertyStageFormat, setPropertyStageFormat] = useState<any[]>([]);
  const [propertySubTypeFormat, setPropertySubTypeFormat] = useState<any[]>([]);
  const [load, setLoad] = useState(false);
  const [locationNames, setLocationNames] = useState<any[]>([]);
  const [showImportLoactionModal, setShowImportLocationModal] = useState<any>(false);
  const [showImportLeadSourceModal, setShowImportLeadSourceModal] = useState<any>(false);
  const [showImportCommercialTypeModal, setShowImportCommercialTypeModal] = useState<any>(false);
  const [showImportBudgetModal, setShowImportBudgetModal] = useState<any>(false);
  const [showImportResidentialTypeModal, setShowImportResidentialTypeModal] = useState<any>(false);
  const [showImportTransferReasonModal, setShowImportTransferReasonModal] = useState<any>(false);
  const [showImportPropertyTypeModal, setShowImportPropertyTypeModal] = useState<any>(false);
  const [showImportPropertyStageModal, setShowImportPropertyStageModal] = useState<any>(false);
  const [showImportPropertySubTypeModal, setShowImportPropertySubTypeModal] = useState<any>(false);
  const [leadSourceColour, setLeadSourceColour] = useState("");

  useEffect(() => {
    if (user.organization_id) {
      const unsub = fetchResources(
        (data) => setLocationsList(data),
        (data) => setBudgetsList(data),
        (data) => setCarouselList(data),
        (data) => setLeadSourceList(data),
        (data) => setComTypes(data),
        (data) => setResTypes(data),
        user.organization_id,
        (data) => setTransferReasons(data),
        (data) => setPropertyTypes(data),
        (data) => setPropertyStage(data),
        (data) => setPropertySubType(data),
      );
      return () => {
        unsub();
      };
    }
  }, [user]);

  const deleteImage = async (index: number, image_name: string) => {
    if (carouselList) {
      setLoad(true);
      await deleteCarouselImage(
        user.organization_id,
        image_name,
        carouselList,
        index,
        dispatcher
      );
      setLoad(false);
    }
  };

  const deleteLocationFirebase = (location: string, index: number) => {
    if (locationsList) {
      setLoad(true);
      deleteLocation(
        location,
        user.organization_id,
        locationsList,
        index,
        dispatcher,
        (data) => setLoad(data)
      );
    }
  };

  const deleteBudgetFirebase = (budget: string, index: number) => {
    if (budgetsList) {
      setLoad(true);

      deleteBudget(
        budget,
        user.organization_id,
        budgetsList,
        index,
        dispatcher,
        (data) => setLoad(data)
      );
    }
  };

  const deleteLeadSourceFirebase = async (leadSource: string, index: number, leadSourceId: any) => {
    if (leadSourceList) {
      setLoad(true);
      await deleteLeadSource(
        leadSource,
        user.organization_id,
        leadSourceList,
        index,
        dispatcher,
        (data) => setLoad(data)
      );
    }
    if (leadSourceId !== '') {
      await deleteApi(
        user.organization_id,
        leadSourceId
      )
    }
  };

  const deleteResidentialType = (residential: string, index: number) => {
    if (resTypes) {
      setLoad(true);
      deleteResidential(
        residential,
        user.organization_id,
        resTypes,
        index,
        dispatcher,
        (data) => setLoad(data)
      );
    }
  };

  const deleteCommercialType = (commercial: string, index: number) => {
    if (comTypes) {
      setLoad(true);
      deleteComType(
        commercial,
        user.organization_id,
        comTypes,
        index,
        dispatcher,
        (data) => setLoad(data)
      );
    }
  };

  const deleteTransferReason = (transferReason: string, index: number) => {
    if (transferReasons) {
      setLoad(true);
      deleteTransferReasonProcess(
        transferReason,
        user.organization_id,
        transferReasons,
        index,
        dispatcher,
        (data) => setLoad(data)
      );
    }
  };

  const deletePropertyStage = (propertySingleStage: string, index: number) => {
    if (propertyStage) {
      setLoad(true);
      deletePropertyStageProcess(
        propertySingleStage,
        user.organization_id,
        propertyStage,
        index,
        dispatcher,
        (data) => setLoad(data)
      );
    }
  };

  const deletePropertyType = (propertySingleType: string, index: number) => {
    if (propertyTypes) {
      setLoad(true);
      deletePropertyTypeProcess(
        propertySingleType,
        user.organization_id,
        propertyTypes,
        propertySubType,
        index,
        dispatcher,
        (data) => setLoad(data)
      );
    }
  };

  const deletePropertySubType = (propertySingleType: any, index: number) => {
    if (propertySubType) {
      setLoad(true);
      deletePropertySubTypeProcess(
        propertySingleType,
        user.organization_id,
        propertyTypes,
        propertySubType,
        index,
        dispatcher,
        (data) => setLoad(data)
      );
    }
  };

  const onEdit = (type: "Location" | "Budget" | "Lead Source" | "Residential" | "Commercial" | "Transfer Reason" | "Property Stage" | "Property Type" | "Property Sub Type", value: string) => {
    setEditModalType(type);
    setEditModal(true);
    setEditValue(value);
  };

  useEffect(() => {
    let l: any = [];
    locationsList?.forEach((item) => {
      l.push(item.location_name);
    });
    setLocationNames(l);
    const formatData = locationsList?.map((list: any) => {
      return {
        ...list,
        created_at: getDateString(list.created_at),
      }
    })
    setLocationsListFormat(formatData);
  }, [locationsList]);

  useEffect(() => {
    const formatData = leadSourceList?.map((list: any) => {
      return {
        ...list,
        created_at: getDateString(list.created_at),
      }
    })
    setLeadSourceListFormat(formatData);
  }, [leadSourceList]);

  useEffect(() => {
    const formatData = budgetsList?.map((list: any) => {
      return {
        ...list,
        created_at: getDateString(list.created_at),
      }
    })
    setBudgetsListFormat(formatData);
  }, [budgetsList]);

  useEffect(() => {
    const formattedData = comTypes.map((type, index) => {
      return { "S No": index + 1, "Commercial Type": type };
    });
    setComTypesFormat(formattedData);
  }, [comTypes]);

  useEffect(() => {
    const formattedData = resTypes.map((type, index) => {
      return { "S No": index + 1, "Residential Type": type };
    });
    setResTypesFormat(formattedData);
  }, [resTypes]);

  useEffect(() => {
    const formattedData = transferReasons.map((type, index) => {
      return { "S No": index + 1, "Transfer Reason": type };
    });
    setTransferReasonsFormat(formattedData);
  }, [transferReasons]);

  useEffect(() => {
    const propTypeHeader = conatctHeader.find((obj: any) => obj.label === "property_type").value;
    const formattedData = propertyTypes.map((type, index) => {
      return { "S No": index + 1, [propTypeHeader]: type };
    });
    setPropertyTypeFormat(formattedData);
  }, [propertyTypes]);

  useEffect(() => {
    const propStageHeader = conatctHeader.find((obj: any) => obj.label === "property_stage").value;
    const formattedData = propertyStage.map((type, index) => {
      return { "S No": index + 1, [propStageHeader]: type };
    });
    setPropertyStageFormat(formattedData);
  }, [propertyStage]);

  useEffect(() => {
    const propTypeHeader = conatctHeader.find((obj: any) => obj.label === "property_type").value;
    const propSubTypeHeader = conatctHeader.find((obj: any) => obj.label === "property_sub_type").value;
    const formattedData = propertySubType.map((type, index) => {
      return { "S No": index + 1, [propTypeHeader]: type.property_type, [propSubTypeHeader]: type.property_sub_type };
    });
    setPropertySubTypeFormat(formattedData);
  }, [propertySubType]);

  const containerStyles = {
    backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    ...fontStylesMedium
  };
  const CARD_HEIGHT = 370; // adjust as needed for your design

  const cardContainerStyles = {
    backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    ...fontStylesMedium,
    borderRadius: 3,
    p: 2,
    mb: 3,
    boxShadow: 2,
    minHeight: CARD_HEIGHT,
    maxHeight: CARD_HEIGHT,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  };

  const thStyles = {
    backgroundColor: theme ? "#E6E6E6 !important" : themeColors.thResourcesBackgroundColorDark,
    ...fontStylesMedium
  };

  const thTextStyles = {
    color: theme ? "rgb(0, 0, 0)" : themeColors.textPrimaryDark,
    padding: "2px !important",
    textAlign: "center",
    fontWeight: "bold",
    ...fontStylesMedium
  };

  const tdStyles = {
    backgroundColor: theme ? themeColors.tdBackgroundColor : themeColors.tdBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    padding: "2px !important",
    textAlign: "center",
    ...fontStylesSmall
  };

  return (
    <>
      <Box className={styles.parent} sx={{
        ...containerStyles,
        mt: isMobile ? 5 : 3,
        minHeight: "105vh",
      }}>
        {carouselList === undefined && (
          <Box className={styles.child}>
            <Loading />
          </Box>
        )}
        <Box className={styles.child} sx={{ ...containerStyles, mb: isMobile ? 9 : 5, p: isMobile ? 1 : 4 }}>
          <Grid container spacing={isMobile ? 2 : 4}>
            <Grid item xs={12} md={6}>
              {/* Carousel Images Card */}
              <Box sx={cardContainerStyles}>
                <Box sx={{ display: "flex", justifyContent: "center", gap: 0.3, mb: 1, backgroundColor: "#272944", borderRadius: 1, p: 0.5 }}>
                  <Typography variant="h6" sx={{ ...fontStylesMedium, color: "#fff" }}>
                    Carousel Images
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mb: 1 }}>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.leftRounded +
                      ' ' +
                      styles.rightRounded
                    }
                    onClick={() => setImportImageModal(true)}
                    icon={<BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Add Image
                  </StyledButtonHeader>
                </Box>
                <Box sx={{ overflowX: "auto", height: 370 }}>
                  <Table>
                    <TableHead>
                      <TableRow
                        sx={{
                          ...thStyles,
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          backgroundColor: thStyles.backgroundColor
                        }}>
                        <TableCell sx={thTextStyles}>Image</TableCell>
                        <TableCell sx={thTextStyles}>Image Name</TableCell>
                        <TableCell sx={thTextStyles}>Created At</TableCell>
                        <TableCell sx={thTextStyles}>Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {carouselList?.map((item: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell sx={tdStyles}>
                            <Avatar src={item.url} variant="rounded" sx={{ width: 56, height: 56 }} />
                          </TableCell>
                          <TableCell sx={tdStyles}>{item.image_name.slice(0, 15)}</TableCell>
                          <TableCell sx={tdStyles}>{getDateString(item.created_at)}</TableCell>
                          <TableCell sx={{ ...tdStyles, width: 40 }}>
                            <MdDelete
                              color={"#ff0000"}
                              size={20}
                              style={{ cursor: "pointer" }}
                              onClick={() => deleteImage(index, item.image_name)}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
              {/* Lead Source Card */}
              <Box sx={cardContainerStyles}>
                <Box sx={{ display: "flex", justifyContent: "center", gap: 0.3, mb: 1, backgroundColor: "#272944", borderRadius: 1, p: 0.5 }}>
                  <Typography variant="h6" sx={{ ...fontStylesMedium, color: "#fff" }}>
                    {conatctHeader.find((obj: any) => obj.label === "lead_source").value}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 0.3, mb: 1 }}>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.leftRounded
                    }
                    onClick={() => setOpenLeadSource(true)}
                    icon={<BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Add
                  </StyledButtonHeader>
                  <StyledButtonHeader
                    onClick={() => setShowImportLeadSourceModal(true)}
                    icon={<BiImport size={16} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Import
                  </StyledButtonHeader>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.rightRounded
                    }
                    icon={<BiExport size={16} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    <CSVLink data={leadSourceListFormat} style={{ color: "#333", textDecoration: "none" }}>
                      Export
                    </CSVLink>
                  </StyledButtonHeader>
                </Box>
                <Box sx={{ overflowX: "auto", height: 370 }}>
                  <Table>
                    <TableHead>
                      <TableRow
                        sx={{
                          ...thStyles,
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          backgroundColor: thStyles.backgroundColor
                        }}
                      >
                        <TableCell sx={thTextStyles}>Edit</TableCell>
                        <TableCell sx={thTextStyles}>{conatctHeader.find((obj: any) => obj.label === "lead_source").value}</TableCell>
                        <TableCell sx={thTextStyles}>Created At</TableCell>
                        <TableCell sx={thTextStyles}>Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {leadSourceList?.map((item: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell sx={tdStyles}>
                            <FiEdit3
                              size={20}
                              color="#272944"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                onEdit("Lead Source", item.leadSource);
                                setLeadSourceId(item.leadSource_id);
                                setLeadSourceColour(item.leadSourceColor);
                              }}
                            />
                          </TableCell>
                          <TableCell sx={tdStyles}>{item.leadSource}</TableCell>
                          <TableCell sx={tdStyles}>{getDateString(item.created_at)}</TableCell>
                          <TableCell sx={{ ...tdStyles, width: 40 }}>
                            <MdDelete
                              color={"#ff0000"}
                              size={20}
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                deleteLeadSourceFirebase(item.leadSource, index, item?.leadSource_id)
                              }
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
              {/* Transfer Reason Card */}
              <Box sx={cardContainerStyles}>
                <Box sx={{ display: "flex", justifyContent: "center", gap: 0.3, mb: 1, backgroundColor: "#272944", borderRadius: 1, p: 0.5 }}>
                  <Typography variant="h6" sx={{ ...fontStylesMedium, color: "#fff" }}>
                    {conatctHeader.find((obj: any) => obj.label === "transfer_reason").value}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 0.3, mb: 1 }}>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.leftRounded
                    }
                    onClick={() => setOpenTransferReason(true)}
                    icon={<BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Add
                  </StyledButtonHeader>
                  <StyledButtonHeader
                    onClick={() => setShowImportTransferReasonModal(true)}
                    icon={<BiImport size={16} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Import
                  </StyledButtonHeader>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.rightRounded
                    }
                    icon={<BiExport size={16} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    <CSVLink data={transferReasonsFormat} style={{ color: "#333", textDecoration: "none" }}>
                      Export
                    </CSVLink>
                  </StyledButtonHeader>
                </Box>
                <Box sx={{ overflowX: "auto", height: 370 }}>
                  <Table>
                    <TableHead>
                      <TableRow
                        sx={{
                          ...thStyles,
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          backgroundColor: thStyles.backgroundColor
                        }}>
                        <TableCell sx={thTextStyles}>Edit</TableCell>
                        <TableCell sx={thTextStyles}>{conatctHeader.find((obj: any) => obj.label === "transfer_reason").value}</TableCell>
                        <TableCell sx={thTextStyles}>Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {transferReasons?.map((item: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell sx={tdStyles}>
                            <FiEdit3
                              size={20}
                              color="#272944"
                              style={{ cursor: "pointer" }}
                              onClick={() => onEdit("Transfer Reason", item)}
                            />
                          </TableCell>
                          <TableCell sx={tdStyles}>{item}</TableCell>
                          <TableCell sx={{ ...tdStyles, width: 40 }}>
                            <MdDelete
                              color={"#ff0000"}
                              size={20}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                deleteTransferReason(item, index);
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
              {/* Property Type Card */}
              <Box sx={cardContainerStyles}>
                <Box sx={{ display: "flex", justifyContent: "center", gap: 0.3, mb: 1, backgroundColor: "#272944", borderRadius: 1, p: 0.5 }}>
                  <Typography variant="h6" sx={{ ...fontStylesMedium, color: "#fff" }}>
                    {conatctHeader.find((obj: any) => obj.label === "property_type").value}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 0.3, mb: 1 }}>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.leftRounded
                    }
                    onClick={() => setOpenPropertyType(true)}
                    icon={<BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Add
                  </StyledButtonHeader>
                  <StyledButtonHeader
                    onClick={() => setShowImportPropertyTypeModal(true)}
                    icon={<BiImport size={16} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Import
                  </StyledButtonHeader>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.rightRounded
                    }
                    icon={<BiExport size={16} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    <CSVLink data={propertyTypeFormat} style={{ color: "#333", textDecoration: "none" }}>
                      Export
                    </CSVLink>
                  </StyledButtonHeader>
                </Box>
                <Box sx={{ overflowX: "auto", height: 370 }}>
                  <Table>
                    <TableHead>
                      <TableRow
                        sx={{
                          ...thStyles,
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          backgroundColor: thStyles.backgroundColor
                        }}>
                        <TableCell sx={thTextStyles}>Edit</TableCell>
                        <TableCell sx={thTextStyles}>{conatctHeader.find((obj: any) => obj.label === "property_type").value}</TableCell>
                        <TableCell sx={thTextStyles}>Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {propertyTypes?.map((item: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell sx={tdStyles}>
                            <FiEdit3
                              size={20}
                              color="#272944"
                              style={{ cursor: "pointer" }}
                              onClick={() => onEdit("Property Type", item)}
                            />
                          </TableCell>
                          <TableCell sx={tdStyles}>{item}</TableCell>
                          <TableCell sx={{ ...tdStyles, width: 40 }}>
                            <MdDelete
                              color={"#ff0000"}
                              size={20}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                deletePropertyType(item, index);
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              {/* Location Card */}
              <Box sx={cardContainerStyles}>
                <Box sx={{ display: "flex", justifyContent: "center", gap: 0.3, mb: 1, backgroundColor: "#272944", borderRadius: 1, p: 0.5 }}>
                  <Typography variant="h6" sx={{ ...fontStylesMedium, color: "#fff" }}>
                    {conatctHeader.find((obj: any) => obj.label === "location").value}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 0.3, mb: 1 }}>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.leftRounded
                    }
                    onClick={() => setOpenLocation(true)}
                    icon={<BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Add
                  </StyledButtonHeader>
                  <StyledButtonHeader
                    onClick={() => setShowImportLocationModal(true)}
                    icon={<BiImport size={16} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Import
                  </StyledButtonHeader>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.rightRounded
                    }
                    icon={<BiExport size={16} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    <CSVLink data={locationsListFormat} style={{ color: "#333", textDecoration: "none" }}>
                      Export
                    </CSVLink>
                  </StyledButtonHeader>
                </Box>
                <Box sx={{ overflowX: "auto", height: 370 }}>
                  <Table>
                    <TableHead>
                      <TableRow
                        sx={{
                          ...thStyles,
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          backgroundColor: thStyles.backgroundColor
                        }}>
                        <TableCell sx={thTextStyles}>Edit</TableCell>
                        <TableCell sx={thTextStyles}>{conatctHeader.find((obj: any) => obj.label === "location").value}</TableCell>
                        <TableCell sx={thTextStyles}>Created At</TableCell>
                        <TableCell sx={thTextStyles}>Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {locationsList?.map((item: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell sx={tdStyles}>
                            <FiEdit3
                              size={20}
                              color="#272944"
                              style={{ cursor: "pointer" }}
                              onClick={() => onEdit("Location", item.location_name)}
                            />
                          </TableCell>
                          <TableCell sx={tdStyles}>{item.location_name}</TableCell>
                          <TableCell sx={tdStyles}>{getDateString(item.created_at)}</TableCell>
                          <TableCell sx={{ ...tdStyles, width: 40 }}>
                            <MdDelete
                              color={"#ff0000"}
                              size={20}
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                deleteLocationFirebase(item.location_name, index)
                              }
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
              {/* Budget Card */}
              <Box sx={cardContainerStyles}>
                <Box sx={{ display: "flex", justifyContent: "center", gap: 0.3, mb: 1, backgroundColor: "#272944", borderRadius: 1, p: 0.5 }}>
                  <Typography variant="h6" sx={{ ...fontStylesMedium, color: "#fff" }}>
                    {conatctHeader.find((obj: any) => obj.label === "budget").value}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 0.3, mb: 1 }}>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.leftRounded
                    }
                    onClick={() => setOpenBudget(true)}
                    icon={<BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Add
                  </StyledButtonHeader>
                  <StyledButtonHeader
                    onClick={() => setShowImportBudgetModal(true)}
                    icon={<BiImport size={16} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Import
                  </StyledButtonHeader>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.rightRounded
                    }
                    icon={<BiExport size={16} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    <CSVLink data={budgetsListFormat} style={{ color: "#333", textDecoration: "none" }}>
                      Export
                    </CSVLink>
                  </StyledButtonHeader>
                </Box>
                <Box sx={{ overflowX: "auto", height: 370 }}>
                  <Table>
                    <TableHead>
                      <TableRow
                        sx={{
                          ...thStyles,
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          backgroundColor: thStyles.backgroundColor
                        }}>
                        <TableCell sx={thTextStyles}>Edit</TableCell>
                        <TableCell sx={thTextStyles}>{conatctHeader.find((obj: any) => obj.label === "budget").value}</TableCell>
                        <TableCell sx={thTextStyles}>Created At</TableCell>
                        <TableCell sx={thTextStyles}>Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {budgetsList?.map((item: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell sx={tdStyles}>
                            <FiEdit3
                              size={20}
                              color="#272944"
                              style={{ cursor: "pointer" }}
                              onClick={() => onEdit("Budget", item.budget)}
                            />
                          </TableCell>
                          <TableCell sx={tdStyles}>{item.budget}</TableCell>
                          <TableCell sx={tdStyles}>{getDateString(item.created_at)}</TableCell>
                          <TableCell sx={{ ...tdStyles, width: 40 }}>
                            <MdDelete
                              color={"#ff0000"}
                              size={20}
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                deleteBudgetFirebase(item.budget, index)
                              }
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
              {/* Property Stage Card */}
              <Box sx={cardContainerStyles}>
                <Box sx={{ display: "flex", justifyContent: "center", gap: 0.3, mb: 1, backgroundColor: "#272944", borderRadius: 1, p: 0.5 }}>
                  <Typography variant="h6" sx={{ ...fontStylesMedium, color: "#fff" }}>
                    {conatctHeader.find((obj: any) => obj.label === "property_stage").value}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 0.3, mb: 1 }}>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.leftRounded
                    }
                    onClick={() => setOpenPropertyStage(true)}
                    icon={<BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Add
                  </StyledButtonHeader>
                  <StyledButtonHeader
                    onClick={() => setShowImportPropertyStageModal(true)}
                    icon={<BiImport size={16} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Import
                  </StyledButtonHeader>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.rightRounded
                    }
                    icon={<BiExport size={16} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    <CSVLink data={propertyStageFormat} style={{ color: "#333", textDecoration: "none" }}>
                      Export
                    </CSVLink>
                  </StyledButtonHeader>
                </Box>
                <Box sx={{ overflowX: "auto", height: 370 }}>
                  <Table>
                    <TableHead>
                      <TableRow
                        sx={{
                          ...thStyles,
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          backgroundColor: thStyles.backgroundColor
                        }}>
                        <TableCell sx={thTextStyles}>Edit</TableCell>
                        <TableCell sx={thTextStyles}>{conatctHeader.find((obj: any) => obj.label === "property_stage").value}</TableCell>
                        <TableCell sx={thTextStyles}>Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {propertyStage?.map((item: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell sx={tdStyles}>
                            <FiEdit3
                              size={20}
                              color="#272944"
                              style={{ cursor: "pointer" }}
                              onClick={() => onEdit("Property Stage", item)}
                            />
                          </TableCell>
                          <TableCell sx={tdStyles}>{item}</TableCell>
                          <TableCell sx={{ ...tdStyles, width: 40 }}>
                            <MdDelete
                              color={"#ff0000"}
                              size={20}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                deletePropertyStage(item, index);
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
              {/* Property Sub Type Card */}
              <Box sx={cardContainerStyles}>
                <Box sx={{ display: "flex", justifyContent: "center", gap: 0.3, mb: 1, backgroundColor: "#272944", borderRadius: 1, p: 0.5 }}>
                  <Typography variant="h6" sx={{ ...fontStylesMedium, color: "#fff" }}>
                    {conatctHeader.find((obj: any) => obj.label === "property_sub_type").value}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 0.3, mb: 1 }}>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.leftRounded
                    }
                    onClick={() => setOpenPropertySubType(true)}
                    icon={<BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Add
                  </StyledButtonHeader>
                  <StyledButtonHeader
                    onClick={() => setShowImportPropertySubTypeModal(true)}
                    icon={<BiImport size={16} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    Import
                  </StyledButtonHeader>
                  <StyledButtonHeader
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.rightRounded
                    }
                    icon={<BiExport size={16} style={{ marginRight: 6, color: '#272944' }} />}
                  >
                    <CSVLink data={propertySubTypeFormat} style={{ color: "#333", textDecoration: "none" }}>
                      Export
                    </CSVLink>
                  </StyledButtonHeader>
                </Box>
                <Box sx={{ overflowX: "auto", height: 370 }}>
                  <Table>
                    <TableHead>
                      <TableRow
                        sx={{
                          ...thStyles,
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          backgroundColor: thStyles.backgroundColor
                        }}>
                        <TableCell sx={thTextStyles}>Edit</TableCell>
                        <TableCell sx={thTextStyles}>{conatctHeader.find((obj: any) => obj.label === "property_type").value}</TableCell>
                        <TableCell sx={thTextStyles}>{conatctHeader.find((obj: any) => obj.label === "property_sub_type").value}</TableCell>
                        <TableCell sx={thTextStyles}>Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {propertySubType?.map((item: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell sx={tdStyles}>
                            <FiEdit3
                              size={20}
                              color="#272944"
                              style={{ cursor: "pointer" }}
                              onClick={() => onEdit("Property Sub Type", item.property_sub_type)}
                            />
                          </TableCell>
                          <TableCell sx={tdStyles}>{item.property_type}</TableCell>
                          <TableCell sx={tdStyles}>{item.property_sub_type}</TableCell>
                          <TableCell sx={{ ...tdStyles, width: 40 }}>
                            <MdDelete
                              color={"#ff0000"}
                              size={20}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                deletePropertySubType(item, index);
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
            </Grid>
          </Grid>
          
          {openLocation && (
            <AddResources
              open={openLocation}
              close={() => setOpenLocation(false)}
              heading={"Location"}
              title={"Enter Location"}
              onSave={(value: any) => {
                if (value === "") {
                  dispatcher(showSnackbarAction("Enter Location!!", "error"));
                } else {
                  setLoad(true);
                  if (locationNames.includes(value)) {
                    dispatcher(
                      showSnackbarAction("This Location Already Exists!!", "info")
                    );
                    setLoad(false);
                    setOpenLocation(false);
                  } else {
                    createLocation(
                      user.organization_id,
                      value,
                      dispatcher,
                      history,
                      (data) => {
                        setOpenLocation(data);
                        setLoad(data);
                      }
                    );
                  }
                }
              }}
            />
          )}

          {openTransferReason && (
            <AddResources
              open={openTransferReason}
              close={() => setOpenTransferReason(false)}
              heading={"Transfer Reason"}
              title={"Enter Reason"}
              onSave={(value: any) => {
                if (value === "") {
                  dispatcher(
                    showSnackbarAction("Enter Transfer Reason!!", "error")
                  );
                } else {
                  setLoad(true);

                  createTransferReason(
                    user.organization_id,
                    value,
                    dispatcher,
                    history,
                    (data) => {
                      setOpenTransferReason(data);
                      setLoad(data);
                    }
                  );
                }
              }}
            />
          )}

          {openPropertyType && (
            <AddResources
              open={openPropertyType}
              close={() => setOpenPropertyType(false)}
              heading={conatctHeader.find((obj: any) => obj.label === "property_type").value}
              title={`Enter ${conatctHeader.find((obj: any) => obj.label === "property_type").value}`}
              onSave={(value: any) => {
                if (value === "") {
                  dispatcher(
                    showSnackbarAction(`Enter ${conatctHeader.find((obj: any) => obj.label === "property_type").value}`, "error")
                  );
                } else {
                  setLoad(true);
                  createPropertyType(
                    user.organization_id,
                    value,
                    dispatcher,
                    history,
                    (data) => {
                      setOpenPropertyType(data);
                      setLoad(data);
                    }
                  );
                }
              }}
            />
          )}

          {openPropertyStage && (
            <AddResources
              open={openPropertyStage}
              close={() => setOpenPropertyStage(false)}
              heading={"Property Stage"}
              title={"Enter Property Stage"}
              onSave={(value: any) => {
                if (value === "") {
                  dispatcher(
                    showSnackbarAction("Enter Property Stage!!", "error")
                  );
                } else {
                  setLoad(true);
                  createPropertyStage(
                    user.organization_id,
                    value,
                    dispatcher,
                    history,
                    (data) => {
                      setOpenPropertyStage(data);
                      setLoad(data);
                    }
                  );
                }
              }}
            />
          )}

          {openPropertySubType && (
            <AddResources
              open={openPropertySubType}
              close={() => setOpenPropertySubType(false)}
              heading={"Property Sub Type"}
              title={"Enter Property Sub Type"}
              onSave={(value: any, type: any) => {
                if (value === "") {
                  dispatcher(
                    showSnackbarAction("Enter Property Sub Type!!", "error")
                  );
                } else if (type.value === "Select") {
                  dispatcher(
                    showSnackbarAction("Enter Property Type!!", "error")
                  );
                } else {
                  setLoad(true);
                  createPropertySubType(
                    user.organization_id,
                    value,
                    type.value,
                    dispatcher,
                    history,
                    (data) => {
                      setOpenPropertySubType(data);
                      setLoad(data);
                    }
                  );
                }
              }}
            />
          )}

          {openBudget && (
            <AddResources
              open={openBudget}
              close={() => setOpenBudget(false)}
              heading={"Budget"}
              title={"Enter Budget"}
              onSave={(value: any) => {
                if (value === "") {
                  dispatcher(showSnackbarAction("Enter Budget!!", "error"));
                } else {
                  setLoad(true);
                  createBudget(
                    user.organization_id,
                    value,
                    dispatcher,
                    history,
                    (data) => {
                      setOpenBudget(data);
                      setLoad(data);
                    }
                  );
                }
              }}
            />
          )}

          {openLeadSource && (
            <AddResources
              open={openLeadSource}
              close={() => setOpenLeadSource(false)}
              heading={"Lead Source"}
              title={"Enter Lead Source"}
              onSave={(value: any, leadSourceColor: any) => {
                if (value === "") {
                  dispatcher(showSnackbarAction("Enter Lead Source!!", "error"));
                } else {
                  const isDuplicate = leadSourceList.some((source) => source.leadSource.toLowerCase() === value.toLowerCase());
                  const leadSource_id = uuidv4();
                  if (isDuplicate) {
                    dispatcher(showSnackbarAction(`The lead source "${value}" already exists and cannot be added.`, "error"));
                    return;
                  }
                  else {
                    setLoad(true);
                    createLeadSource(
                      user.organization_id,
                      value,
                      leadSourceColor,
                      dispatcher,
                      history,
                      (data) => {
                        setOpenLeadSource(data);
                        setLoad(data);
                      },
                      leadSource_id
                    );
                  }
                }
              }}
            />
          )}

          {openCommercial && (
            <AddResources
              open={openCommercial}
              close={() => setOpenCommercial(false)}
              heading={"Commercial Type"}
              title={"Enter Commercial Type"}
              onSave={(value: any) => {
                if (value === "") {
                  dispatcher(
                    showSnackbarAction("Enter Commercial Type!!", "error")
                  );
                } else {
                  setLoad(true);
                  createCommercialType(
                    user.organization_id,
                    value,
                    dispatcher,
                    history,
                    (data) => {
                      setOpenCommercial(data);
                      setLoad(data);
                    }
                  );
                }
              }}
            />
          )}

          {openResidential && (
            <AddResources
              open={openResidential}
              close={() => setOpenResidential(false)}
              heading={"Residential Type"}
              title={"Enter Residential Type"}
              onSave={(value: any) => {
                if (value === "") {
                  dispatcher(
                    showSnackbarAction("Enter Residential Type!!", "error")
                  );
                } else {
                  setLoad(true);

                  createResidentialType(
                    user.organization_id,
                    value,
                    dispatcher,
                    history,
                    (data) => {
                      setOpenResidential(data);
                      setLoad(data);
                    }
                  );
                }
              }}
            />
          )}

          {importImageModal && (
            <ImportImageModal
              open={importImageModal}
              close={() => setImportImageModal(false)}
              organization_id={user.organization_id}
              history={history}
            />
          )}

          {editModal && (
            <EditResources
              open={editModal}
              title={`${editValue}`}
              heading={`Edit ${editModalType}`}
              close={() => setEditModal(false)}
              leadSourceColour={leadSourceColour}
              onSave={(newValue, newLeadSourceColor) => {
                setLoad(true);
                if (editModalType === "Budget") {
                  editBudget(
                    user.organization_id,
                    editValue,
                    newValue,
                    budgetsList,
                    dispatcher,
                    (val: boolean) => {
                      setLoad(val);
                      setEditModal(val);
                    }
                  );
                } else if (editModalType === "Transfer Reason") {
                  editTransferReason(
                    user.organization_id,
                    editValue,
                    newValue,
                    transferReasons,
                    dispatcher,
                    (val: boolean) => {
                      setLoad(val);
                      setEditModal(val);
                    }
                  );
                } else if (editModalType === "Property Stage") {
                  editPropertyStage(
                    user.organization_id,
                    editValue,
                    newValue,
                    propertyStage,
                    dispatcher,
                    (val: boolean) => {
                      setLoad(val);
                      setEditModal(val);
                    }
                  );
                } else if (editModalType === "Property Type") {
                  editPropertyType(
                    user.organization_id,
                    editValue,
                    newValue,
                    propertyTypes,
                    dispatcher,
                    (val: boolean) => {
                      setLoad(val);
                      setEditModal(val);
                    }
                  );
                } else if (editModalType === "Property Sub Type") {
                  editPropertySubType(
                    user.organization_id,
                    editValue,
                    newValue,
                    newLeadSourceColor,
                    propertySubType,
                    dispatcher,
                    (val: boolean) => {
                      setLoad(val);
                      setEditModal(val);
                    }
                  );
                } else if (editModalType === "Lead Source") {
                  const isDuplicate = leadSourceList.some((source) => source.leadSource.toLowerCase() === newValue.toLowerCase());
                  if (isDuplicate) {
                    dispatcher(showSnackbarAction(`The lead source "${newValue}" already exists and cannot be updated.`, "error"));
                    return;
                  }
                  else {
                    editLeadSource(
                      user.organization_id,
                      editValue,
                      newValue,
                      newLeadSourceColor,
                      leadSourceList,
                      dispatcher,
                      (val: boolean) => {
                        setLoad(val);
                        setEditModal(val);
                      }
                    );
                    editAutoApi(
                      user.organization_id,
                      leadSourceId,
                      newValue
                    )
                  }
                } else if (editModalType === "Residential") {
                  editResType(
                    user.organization_id,
                    editValue,
                    newValue,
                    resTypes,
                    dispatcher,
                    (val: boolean) => {
                      setLoad(val);
                      setEditModal(val);
                    }
                  );
                } else if (editModalType === "Commercial") {
                  editCommType(
                    user.organization_id,
                    editValue,
                    newValue,
                    comTypes,
                    dispatcher,
                    (val: boolean) => {
                      setLoad(val);
                      setEditModal(val);
                    }
                  );
                } else {
                  editLocation(
                    user.organization_id,
                    editValue,
                    newValue,
                    locationsList,
                    dispatcher,
                    (val: boolean) => {
                      setLoad(val);
                      setEditModal(val);
                    }
                  );
                }
              }}
            />
          )}

          {showImportLoactionModal && (
            <ImportModelLoaction
              open={showImportLoactionModal}
              close={() => setShowImportLocationModal(false)}
              organization_id={user.organization_id}
              history={history}
              user={user}
            />
          )}

          {showImportLeadSourceModal && (
            <ImportModelLeadSource
              open={showImportLeadSourceModal}
              close={() => setShowImportLeadSourceModal(false)}
              organization_id={user.organization_id}
              history={history}
              user={user}
            />
          )}

          {showImportBudgetModal && (
            <ImportModelBudget
              open={showImportBudgetModal}
              close={() => setShowImportBudgetModal(false)}
              organization_id={user.organization_id}
              history={history}
              user={user}
            />
          )}

          {showImportCommercialTypeModal && (
            <ImportCommercialTypeModal
              open={showImportCommercialTypeModal}
              close={() => setShowImportCommercialTypeModal(false)}
              organization_id={user.organization_id}
              history={history}
              user={user}
            />
          )}

          {showImportResidentialTypeModal && (
            <ImportResidentialTypeModal
              open={showImportResidentialTypeModal}
              close={() => setShowImportResidentialTypeModal(false)}
              organization_id={user.organization_id}
              history={history}
              user={user}
            />
          )}

          {showImportTransferReasonModal && (
            <ImportTransferReasonModal
              open={showImportTransferReasonModal}
              close={() => setShowImportTransferReasonModal(false)}
              organization_id={user.organization_id}
              history={history}
              user={user}
            />
          )}

          {showImportPropertyTypeModal && (
            <ImportPropertyTypeModel
              open={showImportPropertyTypeModal}
              close={() => setShowImportPropertyTypeModal(false)}
              organization_id={user.organization_id}
              history={history}
              user={user}
            />
          )}

          {showImportPropertyStageModal && (
            <ImportPropertyStageModal
              open={showImportPropertyStageModal}
              close={() => setShowImportPropertyStageModal(false)}
              organization_id={user.organization_id}
              history={history}
              user={user}
            />
          )}

          {showImportPropertySubTypeModal && (
            <ImportPropertySubTypeModal
              open={showImportPropertySubTypeModal}
              close={() => setShowImportPropertySubTypeModal(false)}
              organization_id={user.organization_id}
              history={history}
              user={user}
            />
          )}
        </Box>
        {/* ...existing code for modals... */}
      </Box>
    </>
  );
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    contacts: state.contacts,
    theme: state.theme.isLightMode,
    conatctHeader: state.contactHeaderList.data,
  };
};
export default connect(mapStateToProps)(Resources);
